import { render, staticRenderFns } from "./showScreens.vue?vue&type=template&id=ce54285c&scoped=true"
import script from "./showScreens.vue?vue&type=script&lang=js"
export * from "./showScreens.vue?vue&type=script&lang=js"
import style0 from "./showScreens.vue?vue&type=style&index=0&id=ce54285c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce54285c",
  null
  
)

export default component.exports